const firebaseConfig = {
    apiKey: "AIzaSyD5hvi8G_eCC9Xr9NU6fWBHP1WvG083AJU",
    authDomain: "wedreamfly.firebaseapp.com",
    projectId: "wedreamfly",
    storageBucket: "wedreamfly.appspot.com",
    messagingSenderId: "243446696613",
    appId: "1:243446696613:web:732f08c8071ea7fd955b4c"
};

/* const firebaseConfig = {
    apiKey: process.env.React_App_API_KEY,
    authDomain: process.env.React_App_AUTH_DOMAIN,
    projectId: process.env.React_App_PROJECT_ID,
    storageBucket: process.env.React_App_STORAGE_BUCKET,
    messagingSenderId: process.env.React_App_MESSAGING_SENDER_ID,
    appId: process.env.React_App_APP_ID,
}; */

export default firebaseConfig;